import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Switch,
  Tooltip,
  Typography,
} from 'antd';

import {
  CREATING,
  selectors,
  togglePerSectorAlpha,
  togglePayCoupons,
} from 'state';

const OtherSettings: React.FC = () => {
  const dispatch = useDispatch();
  const session = useSelector(selectors.activeSession);
  const perSectorAlphaLocked = session.status !== CREATING;

  return (
    <div>
      <Typography.Title level={3}>Other Settings</Typography.Title>
      <div style={{ display: 'flex', gap: 10, marginTop: '15px' }}>
        <Typography.Text type={'secondary'}>
          Per-sector alpha monitoring:
        </Typography.Text>
        <Tooltip
          title={
            perSectorAlphaLocked
              ? 'Cannot modify after session has been started'
              : ''
          }
        >
          <span>
            <Switch
              checked={session.per_sector_alpha}
              disabled={perSectorAlphaLocked}
              onChange={value => {
                dispatch(
                  togglePerSectorAlpha({
                    session_id: session.id,
                    per_sector_alpha: value,
                  })
                );
              }}
            />
          </span>
        </Tooltip>
      </div>
      <div style={{ display: 'flex', gap: 10, marginTop: '15px' }}>
        {/*<Typography.Text type={'secondary'} style={{ marginTop: '5px' }}>*/}
        <Typography.Text type={'secondary'}>Pay coupons:</Typography.Text>
        {/*<Checkbox*/}
        {/*  checked={session.require_investment_rationale}*/}
        {/*  onChange={e => {*/}
        {/*    dispatch(*/}
        {/*      toggleInvestmentRationale({*/}
        {/*        require_investment_rationale: e.target.checked,*/}
        {/*      })*/}
        {/*    );*/}
        {/*  }}*/}
        {/*/>*/}
        <Switch
          checked={session.pay_coupons}
          onChange={e => {
            dispatch(
              togglePayCoupons({
                pay_coupons: e,
              })
            );
          }}
          // size="small"
        />
        {/*  Require investment rationale*/}
        {/*</Checkbox>*/}
      </div>
    </div>
  );
};

export default OtherSettings;
